import { proxy } from "valtio/vanilla";
import { ISelectedItem, SearchState, SearchTabId } from "react-migration/domains/search/typings";
import { ICheckboxFilter } from "@landtechnologies/dtos";

export type SearchStore = SearchState & {
  savedResults: boolean;
  savedResultsError: string;
  boundaryFilters: ICheckboxFilter[];
};

export const defaultState: SearchStore = {
  searchId: "",
  searchResultsLoading: false,
  searchResults: undefined,
  selectedItemsById: new Map<string, ISelectedItem>(),
  selectedFilters: [],
  mapDragged: false,
  panSearchCheck: false,
  searchOnMapChange: false,
  activeTab: SearchTabId.filters,
  searchToDelete: undefined,
  savedResults: false,
  savedResultsError: "",
  get isClusteredParcelSearch() {
    return this.selectedFilters.some((filter) => filter.id === "lot-cluster-area-id");
  },
  boundaryFilters: [],
};

export const createSearchStore = () => defaultState;
const searchStore = proxy<SearchStore>(createSearchStore());

const localStorageKey = "searchState";
// const storedStateString = localStorage.getItem(localStorageKey);
// const previousSearchStore = storedStateString ? JSON.parse(storedStateString) : {};
// export const createSearchStore = () => Object.assign(defaultState, previousSearchStore);
// const searchStore = proxy<SearchStore>(createSearchStore());
export { searchStore, localStorageKey };
